import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import LinkChoicePop from './LinkChoicePop.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  urls: {
    type: Array,
    default: () => [],
  },
},
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {



const isMountedRef = ref(false)
const floatupRef = ref(0)



const { close, zIndex } = usePromisifyDialog(emit)

const handleClose = () => {
  isMountedRef.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}


onMounted(async () => {
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (isMountedRef.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["pop-wrapper", { 'is-mounted': isMountedRef.value }]),
          style: _normalizeStyle({ zIndex: Math.max(_unref(zIndex), floatupRef.value) })
        }, [
          _createVNode(LinkChoicePop, {
            urls: __props.urls,
            onOnClose: _cache[0] || (_cache[0] = ($event: any) => (handleClose()))
          }, null, 8, ["urls"])
        ], 6))
      : _createCommentVNode("", true)
  ]))
}
}

})